var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './main.scss';
import Modal from './PartnerDetailsModal';
import SearchIcon from '../../assets/images/logoListDisplay/search.png';
import PlusIcon from '../../assets/images/logoListDisplay/plus.png';
import MinusIcon from '../../assets/images/logoListDisplay/minus.png';
import closeButton from '../../assets/images/logoListDisplay/clear_all.png';
var LogoListDisplay = function (_a) {
    var partner_data = _a.data.partner_data;
    var _b = useState(partner_data), partnerDetails = _b[0], updatePartnerDetails = _b[1];
    var _c = useState(false), isPartnerSelected = _c[0], updateIsSelectedPartner = _c[1];
    var _d = useState({
        title: '',
        category: [
            {
                id: '',
                label: '',
            },
        ],
        attributes: [
            {
                attribute_type: '',
                attribute_value: '',
            },
        ],
        description: '',
        logo: '',
        search_tags: [
            {
                label: '',
            },
        ],
        cta: [
            {
                url: '',
                title: '',
                is_external: true,
            },
        ],
        description_with_cta: [],
    }), modalData = _d[0], updateModalData = _d[1];
    var _e = useState([]), filterTagArray = _e[0], setFilterTagArray = _e[1];
    var _f = useState(''), searchValue = _f[0], updateSearchValue = _f[1];
    var _g = useState(true), seeMore = _g[0], setSeeMore = _g[1];
    var _h = useState(true), searchResults = _h[0], setSearchResults = _h[1];
    var _j = useState(0), contentHeight = _j[0], setContentHeight = _j[1];
    var _k = useState(0), containerHeight = _k[0], setContainerHeight = _k[1];
    var filterRef = useRef();
    var filterListTag = [];
    var temp = [];
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    partner_data.map(function (item, index) {
        item.category.map(function (list) {
            if (!temp.includes(list.label) &&
                list.label != '' &&
                list.label != null) {
                temp.push(list.label);
                temp.sort(function (a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                });
            }
        });
    });
    temp.forEach(function (value) {
        if (!filterListTag.includes(value)) {
            filterListTag === null || filterListTag === void 0 ? void 0 : filterListTag.push(value);
        }
    });
    var index = filterListTag.indexOf('Featured');
    if (index > -1) {
        // only splice array if Featured Tag is found
        filterListTag.splice(index, 1);
        filterListTag.unshift('Featured');
    }
    useLayoutEffect(function () {
        var _a, _b;
        if (filterRef && filterRef.current) {
            setContainerHeight((_a = filterRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
            setContentHeight((_b = filterRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight);
        }
    }, [filterRef]);
    useEffect(function () {
        // removed logic for auto selection of Featured tag on page load under ENV1-282
        // const item = document.querySelector('.filterItem') as HTMLElement;
        // if (item.innerText == 'Featured') {
        //   const itemCheckbox = document.querySelector('.filter-tags');
        //   (itemCheckbox as HTMLInputElement).checked = true;
        //   selectedFilter('Featured');
        // }
        function handleWindowResize() {
            var _a, _b;
            if (filterRef && filterRef.current) {
                setContainerHeight((_a = filterRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
                setContentHeight((_b = filterRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight);
            }
        }
        window.addEventListener('resize', handleWindowResize);
        return function () {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    useEffect(function () {
        var urlIds = window.location.href.split('#');
        // const id = urlIds ? urlIds[urlIds.length - 1] : null;
        if (urlIds && urlIds[1]) {
            partnerDetails.map(function (item, index) {
                if (item.title
                    .replace(/ *\([^)]*\) */g, '')
                    .replace(/[^a-zA-Z0-9 ]/g, '')
                    .replace(/\s+/g, '-')
                    .toLowerCase() === urlIds[1].toLowerCase()) {
                    updateIsSelectedPartner(true);
                    selectedPartner(item);
                }
            });
        }
    }, []);
    var uncheckAllFilters = function () {
        var _a;
        setSearchResults(true);
        var items = document.querySelectorAll('.filter-tags');
        var i;
        for (i = 0; i < items.length; i++) {
            if (((_a = items[i]) === null || _a === void 0 ? void 0 : _a.checked) == true) {
                items[i].checked = false;
            }
        }
        setFilterTagArray([]);
        updatePartnerDetails(partner_data);
    };
    var selectedFilter = function (item) {
        var _a, _b;
        updateSearchValue('');
        if (filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.includes(item)) {
            filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.splice(filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.indexOf(item), 1);
        }
        else {
            filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.push(item);
        }
        var filterList = [];
        var result;
        // Logic for OR
        // filterTagArray.map((tag: string) => {
        //   data1.partner_data.filter((items) => {
        //     console.log(items);
        //     items.category.map((item) => {
        //       if (item.label === tag) {
        //         if (!filterList.includes(items)) {
        //           filterList.push(items);
        //         }
        //       }
        //     });
        //   });
        // });
        // Logic for AND
        partner_data === null || partner_data === void 0 ? void 0 : partner_data.filter(function (items) {
            var _a;
            var filterLabelArray = (_a = items === null || items === void 0 ? void 0 : items.category) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                return item.label;
            });
            result = filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.every(function (item) {
                return filterLabelArray === null || filterLabelArray === void 0 ? void 0 : filterLabelArray.includes(item);
            });
            if (result) {
                filterList === null || filterList === void 0 ? void 0 : filterList.push(items);
            }
        });
        if ((filterList === null || filterList === void 0 ? void 0 : filterList.length) == 0) {
            setSearchResults(false);
        }
        else {
            setSearchResults(true);
        }
        if ((filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.length) != 0) {
            updatePartnerDetails(filterList);
            (_a = document
                .querySelector('.logo-list-display-clear-all')) === null || _a === void 0 ? void 0 : _a.classList.add('show');
        }
        else {
            updatePartnerDetails(partner_data);
            (_b = document
                .querySelector('.logo-list-display-clear-all')) === null || _b === void 0 ? void 0 : _b.classList.remove('show');
        }
    };
    var selectedPartner = function (item) {
        updateModalData(__assign(__assign({}, modalData), { title: item === null || item === void 0 ? void 0 : item.title, attributes: item === null || item === void 0 ? void 0 : item.attributes, logo: item === null || item === void 0 ? void 0 : item.logo, cta: item === null || item === void 0 ? void 0 : item.cta, description: item === null || item === void 0 ? void 0 : item.description, category: item === null || item === void 0 ? void 0 : item.category, description_with_cta: item === null || item === void 0 ? void 0 : item.description_with_cta }));
        //regex1: remove text in brackets, regex2: remove special characters, regex3: remove spaces and replace with -
        navigate(pathname + "#" + item.title
            .replace(/ *\([^)]*\) */g, '')
            .replace(/[^a-zA-Z0-9 ]/g, '')
            .replace(/\s+/g, '-')
            .toLowerCase(), {
            replace: true,
        }); //ENV1-584: URL to match the modal title that's opened
        updateIsSelectedPartner(true);
        document.body.classList.add('no-scroll');
    };
    var closeModal = function () {
        updateIsSelectedPartner(false);
        document.body.classList.remove('no-scroll');
        navigate({ pathname: pathname }, { replace: true }); //ENV1-584: URL to match the base URL
    };
    var inputSearchPartner = function (e) {
        var _a;
        updateSearchValue((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
        var filterList = partner_data === null || partner_data === void 0 ? void 0 : partner_data.filter(function (items) {
            var _a, _b, _c, _d, _e;
            var itemSearchTagList = (_a = items === null || items === void 0 ? void 0 : items.search_tags) === null || _a === void 0 ? void 0 : _a.map(function (item) { var _a, _b, _c, _d; return (_b = (_a = item === null || item === void 0 ? void 0 : item.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes((_d = (_c = e.target) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.toLowerCase()); });
            if (((_c = (_b = items === null || items === void 0 ? void 0 : items.title) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes((_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.toLowerCase())) ||
                (itemSearchTagList === null || itemSearchTagList === void 0 ? void 0 : itemSearchTagList.includes(true))) {
                return true;
            }
        });
        if ((filterList === null || filterList === void 0 ? void 0 : filterList.length) !== 0) {
            setSearchResults(true);
        }
        else {
            setSearchResults(false);
        }
        updatePartnerDetails(filterList);
    };
    var seeMoreCount = function () {
        var filterItems = document.querySelector('.filter-list');
        if (seeMore) {
            if (filterItems) {
                filterItems.style.maxHeight = 'max-content';
                filterItems.style.overflow = 'inherit';
            }
        }
        else {
            if (window.innerWidth < 768) {
                if (filterItems) {
                    filterItems.style.maxHeight = '120px';
                    filterItems.style.overflow = 'hidden';
                }
            }
            else {
                if (filterItems) {
                    filterItems.style.maxHeight = '89px';
                    filterItems.style.overflow = 'hidden';
                }
            }
        }
        window.addEventListener('resize', seeMoreCount);
    };
    var renderSeeMore = function () {
        var el = (_jsx("div", __assign({ className: "logo-list-display-see-more-container" }, { children: _jsx("p", __assign({ className: "see-more", onClick: function () {
                    seeMoreCount();
                    setSeeMore(!seeMore);
                } }, { children: seeMore ? (_jsxs(_Fragment, { children: [_jsx("span", { children: "SEE MORE" }, void 0),
                        _jsx("img", { src: PlusIcon, alt: "Plus Icon" }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx("span", { children: "SEE LESS" }, void 0),
                        _jsx("img", { src: MinusIcon, alt: "Minus Icon" }, void 0)] }, void 0)) }), void 0) }), void 0));
        if (containerHeight + 3 < contentHeight) {
            return el;
        }
    };
    return (_jsxs("div", __assign({ className: "logo-list-display-container" }, { children: [_jsxs("div", __assign({ className: "logo-list-display-search" }, { children: [_jsx("img", { className: "logo-list-display-search-image", src: SearchIcon, alt: "Search Icon" }, void 0),
                    _jsx("input", { className: "logo-list-display-search-partner", value: searchValue, type: "search", placeholder: "Search for an app", onChange: inputSearchPartner, onClick: function () {
                            var _a;
                            uncheckAllFilters();
                            (_a = document
                                .querySelector('.logo-list-display-clear-all')) === null || _a === void 0 ? void 0 : _a.classList.remove('show');
                        } }, void 0)] }), void 0),
            _jsxs("div", __assign({ className: "logo-list-display-category-clear-filter" }, { children: [_jsx("div", __assign({ className: "logo-list-display-categories-text" }, { children: "Categories" }), void 0),
                    _jsxs("div", __assign({ className: "logo-list-display-clear-all", onClick: function () {
                            var _a;
                            uncheckAllFilters();
                            (_a = document
                                .querySelector('.logo-list-display-clear-all')) === null || _a === void 0 ? void 0 : _a.classList.remove('show');
                        } }, { children: [_jsx("span", { children: "Clear All" }, void 0),
                            _jsx("img", { src: closeButton, alt: "close icon", className: "logo-list-display-clear-all-close-icon" }, void 0)] }), void 0)] }), void 0),
            _jsx("div", { className: "logo-list-display-clear-all-divider" }, void 0),
            _jsx("div", __assign({ className: "logo-list-display-filter-list-container" }, { children: _jsx("ul", __assign({ className: "filter-list", ref: filterRef }, { children: filterListTag === null || filterListTag === void 0 ? void 0 : filterListTag.map(function (item, index) {
                        return (_jsxs("div", { children: [_jsx("input", { className: "filter-tags", type: "checkbox", id: index === null || index === void 0 ? void 0 : index.toString() }, void 0),
                                _jsx("label", __assign({ htmlFor: index === null || index === void 0 ? void 0 : index.toString(), className: "filterItem filterItem-" + index, onClick: function (e) {
                                        selectedFilter(item);
                                    } }, { children: item
                                        .split(' ')
                                        .map(function (item) {
                                        return (item[0].toUpperCase() + item.substring(1, item.length));
                                    })
                                        .join(' ') }), void 0)] }, index));
                    }) }), void 0) }), void 0), renderSeeMore(), !searchResults ? (_jsx("div", __assign({ className: "logo-list-display-no-result-text" }, { children: _jsx("p", { children: "No Partners Found" }, void 0) }), void 0)) : (_jsxs("div", __assign({ className: "logo-list-display-section mx-auto" }, { children: [_jsx("div", __assign({ className: "logo-list-display-images" }, { children: partnerDetails === null || partnerDetails === void 0 ? void 0 : partnerDetails.map(function (item, index) {
                            return (_jsx("div", __assign({ className: "logo-list-display-image-container", onClick: function (e) { return selectedPartner(item); } }, { children: (item === null || item === void 0 ? void 0 : item.logo) && (_jsx("img", { className: "logo-list-display-image", src: item === null || item === void 0 ? void 0 : item.logo, alt: item === null || item === void 0 ? void 0 : item.title }, void 0)) }), index));
                        }) }), void 0),
                    isPartnerSelected ? (_jsx(Modal, { modalData: modalData, closeModal: closeModal }, void 0)) : ('')] }), void 0))] }), void 0));
};
export default LogoListDisplay;
